import React, { useEffect, useState, useCallback } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import apiClient from 'apiClient';
import ErrorManager from 'shared/Messages/ErrorManager';
import { dashboard } from 'routes/routePaths';
import FirstStepForm from 'components/Clubs/StepFirstForm';
import { Option } from 'shared/interface/globalInterface';
import { ClubRegisterData } from 'store/clubs/types/types';
import { clearClubsData } from 'store/clubs/actions';
import dataMapper from 'pages/Clubs/Register/dataMapper';
import Success from 'components/Statuses/Success';

const ClubRegistrationFirstStep: React.FC<RouteComponentProps> = ({ history }) => {
  const dispatch = useDispatch();
  const formData: ClubRegisterData = useSelector((state: any) => state.clubs.clubDetails);

  const [error, setError] = useState<string>('');
  const [commissionTerms, setCommissionTerms] = useState<Option[]>([]);
  const [success, setSuccess] = useState<boolean>(false);

  useEffect(() => {
    dispatch(clearClubsData([]));

    let shouldCancel: boolean = false;
    const getCommissionTerms = async () => {
      try {
        const { data } = await apiClient.get(`/api/v1/broker-management/standard-commission-terms/`);
        if (!shouldCancel) setCommissionTerms(data);
      } catch (err) {
        if (!shouldCancel) setError('Cannot get data.');
      }
    };
    getCommissionTerms();

    return () => {
      shouldCancel = true;
    };
  }, [dispatch]);

  const goBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const goDashboard = useCallback(() => {
    history.push(dashboard);
  }, [history]);

  const handleSubmit = async (values: ClubRegisterData) => {
    const formData = dataMapper.map(values, []);

    try {
      await apiClient.post('/api/v1/broker-management/create-club/', formData);
      setSuccess(true);
    } catch (err) {
      setError(err.response);
    }
  };

  return success ? (
    <Success onConfirm={goDashboard} />
  ) : (
    <>
      <h2 className="page-title">Register New Club - Step 1</h2>
      <FirstStepForm
        handleSubmit={handleSubmit}
        formData={formData}
        commissionTerms={commissionTerms}
        goBack={goBack}
      />
      {error ? <ErrorManager error={error} /> : null}
    </>
  );
};

export default ClubRegistrationFirstStep;
